export default "__VITE_PUBLIC_ASSET__0626c479__"